import 'jquery.payment';

/**
 * Add jquery-payment masks to inputs via a directive
 * @deprecated - replace with vue-stripe-payment
 */
export default {
    bind(el, binding) {
        $(el).payment(binding.arg);
    },
}
